import { each } from '@antv/util';
// 自定义 Behavior 时候共有的方法
export default {
  getDefaultCfg: function getDefaultCfg() {
    return {};
  },
  /**
   * register event handler, behavior will auto bind events
   * for example:
   * return {
   *  click: 'onClick'
   * }
   */
  getEvents: function getEvents() {
    return {};
  },
  updateCfg: function updateCfg(cfg) {
    Object.assign(this, cfg);
    return true;
  },
  shouldBegin: function shouldBegin() {
    return true;
  },
  shouldUpdate: function shouldUpdate() {
    return true;
  },
  shouldEnd: function shouldEnd() {
    return true;
  },
  /**
   * auto bind events when register behavior
   * @param graph Graph instance
   */
  bind: function bind(graph) {
    var _this = this;
    var events = this.events;
    this.graph = graph;
    if (this.type === 'drag-canvas' || this.type === 'brush-select' || this.type === 'lasso-select') {
      graph.get('canvas').set('draggable', true);
    }
    each(events, function (handler, event) {
      graph.on(event, handler);
    });
    // To avoid the tabs switching makes the keydown related behaviors disable
    this.handleVisibilityChange = function () {
      _this.keydown = false;
    };
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  unbind: function unbind(graph) {
    var events = this.events;
    var draggable = graph.get('canvas').get('draggable');
    if (this.type === 'drag-canvas' || this.type === 'brush-select' || this.type === 'lasso-select') {
      graph.get('canvas').set('draggable', false);
    }
    each(events, function (handler, event) {
      graph.off(event, handler);
    });
    graph.get('canvas').set('draggable', draggable);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  get: function get(val) {
    return this[val];
  },
  set: function set(key, val) {
    this[key] = val;
    return this;
  }
};